import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTanzania = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1144)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.5147 20.4853C4.0181 20.9887 4.55519 21.4376 5.11858 21.8329L21.8328 5.11861C21.4376 4.55522 20.9887 4.01813 20.4853 3.51474C19.9818 3.01135 19.4448 2.56247 18.8814 2.16722L2.16724 18.8815C2.56239 19.4447 3.01136 19.9819 3.5147 20.4853Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51484 3.51487C-0.270885 7.30068 -0.997682 12.9862 1.33308 17.5023L17.5022 1.33317C12.9862 -0.9976 7.3006 -0.270757 3.51484 3.51487Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.4853 20.4853C24.271 16.6996 24.9978 11.014 22.6671 6.49791L6.49792 22.6671C11.0139 24.9978 16.6995 24.271 20.4853 20.4853Z",
				fill: "#338AF3"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1144",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgTanzania;
